// extracted by mini-css-extract-plugin
export var content = "_nm-1";
export var fullScreen = "_nm-0";